<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
            </div>
        </div>
        <div class="primary-bg pl20 pr20 pb10">
            <h3 class="pb10 pt10 white m0">Akun</h3>
            <h2 class="white mb0">{{get.data.nama}} <small>({{get.data.prefix+""+get.data.fake_id}})</small></h2>
            <span class="white m0">{{get.data.hp}}</span>
        </div>
        <div class="wrapper">
            <div class="body">
                <div class=" mb10 mt10" >
                    <div class="data bg-round-white p10">
                        <div class="box-horizontal">
                            <div class="flex-1">
                                <small class="block gray">Paket</small>
                                <span class="block f15 primary-color">{{get.data.paket}} - {{get.data.tarif}}</span>
                            </div>
                        </div>
                        <div class="box-horizontal">
                            <div class="flex-1 f13">
                                <small class="block gray">Area</small>
                                <span class="block f12 primary-color">{{get.data.area}}</span>
                            </div>
                        </div>
                        <div class="box-horizontal" v-show="false">
                            <div class="flex-1 f13">
                                <small class="block gray">Penggunaan</small>
                                <span class="block f12 primary-color">{{myGlobal.ribuNoRp(get.data.bandwith)}} mb</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" mb10 mt10 bg-round-white" >
                    <div class="data p10 bt-1">
                        <div class="box-horizontal " @click="met.pengaduan()">
                            <div class="flex-1 primary-color">
                                Pengaduan
                            </div>
                            <div style="height:30px">
                                <img src="@/assets/right-gray.png" alt="" style="height:30px">
                            </div>
                        </div>
                    </div>
                    <div class="data p10 bt-1">
                        <div class="box-horizontal" @click="met.wa()">
                            <div class="flex-1 primary-color">
                                Hubungi Admin
                            </div>
                            <div class="hitam"><span v-if="get.data.cs_nama != null">{{ get.data.cs_nama }}<br></span>{{ get.data.cs }}</div>
                            <div style="height:30px">
                                <img src="@/assets/right-gray.png" alt="" style="height:30px">
                            </div>
                        </div>
                    </div>
                    <div class="data p10 bt-1">
                        <div class="box-horizontal" @click="met.kebijakan()">
                            <div class="flex-1 primary-color">
                                Kebijakan Privasi
                            </div>
                            <div class="hitam"></div>
                            <div style="height:30px;opacity: 0">
                                <img src="@/assets/right-gray.png" alt="" style="height:30px">
                            </div>
                        </div>
                    </div>
                    <div class="data p10">
                        
                        <div class="box-horizontal">
                            <div class="flex-1 primary-color">
                                Versi
                            </div>
                            <div class="hitam">{{myGlobal.versi()}}</div>
                            <div style="height:30px;opacity: 0">
                                <img src="@/assets/right-gray.png" alt="" style="height:30px">
                            </div>
                        </div>
                    </div>
                </div>

                <button class="btn btn-red" @click="met.logout()">Logout</button>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                nama: 'Contoh',
                fake_id: '',
                prefix: '',
                paket: 'Contoh Paket',
                area: 'Areaku',
                tarif: 'Rp. 0',
                params: '',
                cs: '',
                cs_nama: '',
                bandwith: '0',
                hp: ''
            }),
            list() {
                var datax = {
                    token: 'TangTung ' //+sessionStorage.getItem('Token')
                };
            
                var apiUrl = inter.KategoriList();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        mainData.data = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
            }
        }
        const met = {
            back() {
                window.history.back();
            },
            logout() {
                
                if (sessionStorage.getItem("browserToken") != null) {
                    sessionStorage.removeItem("data_profil")
                    localStorage.removeItem("browserToken");
                    sessionStorage.removeItem("browserToken");
                    router.push({ 
                        name: 'login'
                    });
                } else {
                myGlobal.android("logout" , null);
                }
            },
            wa() {
                if (sessionStorage.getItem("browserToken") != null) {
                    var telp = get.data.cs.replace(/[^0-9.]/g, '');
                    var awal = telp.substring(0, 1);

                    if (awal == "0") {
                        telp = "62" + telp.substring(1);
                    }
                    
                    //console.log(telp);

                    window.open('https://wa.me/'+telp,'_blank');

                } else {
                    myGlobal.android("waCS" , get.data.cs);
                }
            },
            pengaduan() {
                router.push({ 
                    name: 'pengaduan'
                });
            },
            kebijakan() {
                if (sessionStorage.getItem("browserToken") != null) {

                    window.open('https://beatcom.web.id/kebijakan-privasi.html','_blank');

                } else {
                    myGlobal.android("openlink" , "https://beatcom.web.id/kebijakan-privasi.html");
                }

            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx,
            myGlobal
        }

    },
    mounted () {        
        this.redirectx.checkApp();
        
        //console.log(sessionStorage.getItem('AkunPageData'));
        
        //console.log(JSON.stringify(sessionStorage.getItem('AkunPageData')));

        if (sessionStorage.getItem('AkunPageData') == null) {
            this.get.data.params = this.$route.params.data;
            sessionStorage.setItem('AkunPageData', JSON.stringify(this.$route.params.data))
        } else {
            //console.log(sessionStorage.getItem('AkunPageData'));
            this.get.data.params = JSON.parse(sessionStorage.getItem('AkunPageData'));
        }


        var d = this.get.data.params;
        
        //console.log(JSON.stringify(d));
        
        this.get.data.nama = d.nama;
        this.get.data.paket = d.paket;
        this.get.data.area = d.area;
        this.get.data.cs = d.cs;
        this.get.data.cs_nama = d.cs_nama; 
        this.get.data.tarif = d.tarif; 
        this.get.data.fake_id = d.fake_id; 
        this.get.data.prefix = d.prefix; 
        this.get.data.hp = d.wa; 

        //myGlobal.android("toast", myGlobal.androidGet("latlng") );
        
        // console.log(this.get.data.cs_nama);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Akun/main.vue